import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  clientIdLabel: {
    id: 'studio.uAPm+d',
    defaultMessage: 'Client id',
  },
  clientIdHelp: {
    id: 'studio.dn2v/w',
    defaultMessage: 'The client id used to authenticate for the OAuth client credentials flow',
  },
  clientSecretLabel: {
    id: 'studio.B7p2EC',
    defaultMessage: 'Client secret',
  },
  clientSecretHelp: {
    id: 'studio.VRt6/G',
    defaultMessage: 'The client secret used to authenticate for the OAuth client credentials flow',
  },
  tokenUrlLabel: {
    id: 'studio.PJhe0H',
    defaultMessage: 'Token URL',
  },
  tokenUrlHelp: {
    id: 'studio.GbCZS7',
    defaultMessage: 'The URL to retrieve the token form',
  },
  scopeLabel: {
    id: 'studio.nso3Mj',
    defaultMessage: 'Scope',
  },
  scopeHelp: {
    id: 'studio.RODeNG',
    defaultMessage: 'The scope to retrieve the token for',
  },
});
